import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import { useSearchWorkers } from "../../../context/SearchWorkersContext";

const WorkerCareActivitiesComponent = ({
  onUpdate,
  selectedActivitiesValue = [],
  selectedSupportTypes = [],
  isError,
  errorMessage,
  clearError,
}) => {
  const {
    getSelectionIdFromCookies,
    searchSelections,
    fetchActivitiesBySupportTypeLabel,
  } = useSearchWorkers();

  const supportTypeDetails =
    Array.isArray(selectedSupportTypes) && selectedSupportTypes.length > 0
      ? selectedSupportTypes
      : Array.isArray(searchSelections?.supportTypeDetails)
      ? searchSelections.supportTypeDetails
      : [];

  const [selectedActivities, setSelectedActivities] = useState(() => {
    const initial = {};
    const activities = selectedActivitiesValue.length
      ? selectedActivitiesValue
      : searchSelections?.careActivityDetails || [];
    activities.forEach((activity) => (initial[activity] = true));
    return initial;
  });

  const [localErrorMessage, setLocalErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [activitiesData, setActivitiesData] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    const selectionId = getSelectionIdFromCookies();
    console.log(
      "[WorkerCareActivitiesComponent] Retrieved selectionId from cookies:",
      selectionId
    );
    if (!selectionId) {
      console.warn("No selectionId found. Redirecting to /search-workers...");
      navigate("/account/fs-dashboard/search-workers");
    }
  }, [getSelectionIdFromCookies, navigate]);

  useEffect(() => {
    console.log(
      "[WorkerCareActivitiesComponent] Initial Support Type Details:",
      supportTypeDetails
    );
  }, []);

  useEffect(() => {
    const selectedKeys = Object.keys(selectedActivities).filter(
      (key) => selectedActivities[key]
    );
    onUpdate(selectedKeys);
  }, [selectedActivities, onUpdate]);

  useEffect(() => {
    const selectedKeys = Object.keys(selectedActivities).filter(
      (key) => selectedActivities[key]
    );
    if (selectedKeys.length === 0 && isError) {
      setLocalErrorMessage(
        errorMessage || "Please select at least one activity."
      );
    } else {
      setLocalErrorMessage("");
      clearError && clearError();
    }
  }, [isError, errorMessage, clearError, selectedActivities]);

  useEffect(() => {
    if (searchSelections?.careActivityDetails) {
      const initialSelected = {};
      searchSelections.careActivityDetails.forEach(
        (activity) => (initialSelected[activity] = true)
      );
      setSelectedActivities(initialSelected);
    }
  }, [searchSelections]);

  useEffect(() => {
    console.log(
      "[WorkerCareActivitiesComponent] Using Support Type Details:",
      supportTypeDetails
    );

    if (supportTypeDetails.length > 0) {
      getActivityData()
        .then(setActivitiesData)
        .catch((error) => {
          console.error("Failed to load activities:", error);
          setActivitiesData([]);
        });
    } else {
      setActivitiesData([]);
    }
  }, [supportTypeDetails]);

  const getActivityData = async () => {
    setLoading(true);
    let activities = [];

    if (Array.isArray(supportTypeDetails)) {
      for (const supportTypeLabel of supportTypeDetails) {
        try {
          const fetchedActivities = await fetchActivitiesBySupportTypeLabel(
            supportTypeLabel
          );
          activities = activities.concat(fetchedActivities);
        } catch (error) {
          console.error(
            `Error fetching activities for support type label "${supportTypeLabel}":`,
            error
          );
        }
      }
    } else {
      console.error(
        "supportTypeDetails is not a valid array:",
        supportTypeDetails
      );
    }

    setLoading(false);
    return activities.map((activity) => ({
      label: activity.name || activity.label,
      description: activity.description,
    }));
  };

  const toggleActivity = (label) => {
    setSelectedActivities((prevState) => {
      const newState = { ...prevState, [label]: !prevState[label] };
      return newState;
    });
    clearError && clearError();
  };

  return (
    <div className="care-activities-container">
      <h2>Which activities need support?</h2>
      <div className="care-activities-scrollable">
        {loading ? (
          <div style={{ textAlign: "left", marginLeft: "20px" }}>
            <RotatingLines
              visible={true}
              height="76"
              width="36"
              color="grey"
              strokeWidth="3"
              animationDuration="0.75"
              ariaLabel="rotating-lines-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        ) : activitiesData.length > 0 ? (
          activitiesData.map((activity, index) => (
            <button
              key={index}
              className={`activities-horizontal-button ${
                selectedActivities[activity.label] ? "selected" : ""
              }`}
              onClick={() => toggleActivity(activity.label)}
            >
              <div className="button-checkmark">
                {selectedActivities[activity.label] ? "✓" : ""}
              </div>
              <div className="button-text">{activity.label}</div>
            </button>
          ))
        ) : (
          <p>No activities available for the selected support types.</p>
        )}
        {localErrorMessage && (
          <span className="wcac-error-message">{localErrorMessage}</span>
        )}
      </div>
    </div>
  );
};

export default WorkerCareActivitiesComponent;
